export class ElectronicSalesConnection {
    eclassVersion = "";
    domain = "";
    updateMode = "";
    ftpServerId = 0;
    productFilePath = "";
    categoryFilePath = "";
    featureFilePath = "";
}
